const styleSheet = () => ({
  container: {
    position: 'fixed',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: (props: any) => (props.show ? 100000 : -1),
  },
  containerWrapper: {
    boxSizing: 'border-box',
    margin: 'auto',
    verticalAlign: 'middle',
  },
  card: {
    position: 'relative',
    opacity: 0,
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 4px 20px 0 rgba(0,0,0,0.4)',
    overflow: 'hidden',
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
  },
  cardWrapper: {
    maxHeight: '100vh',
    boxSizing: 'border-box',
    width: '1210px',
    height: '100vh',
  },
  closer: {
    backgroundColor: 'rgba(0,0,0,0.7)',
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    cursor: 'pointer',
    opacity: 0,
  },
  crossMark: {
    position: 'absolute',
    top: '-20px',
    right: '25px',
    fontSize: '26px',
    color: '#979797',
    lineHeight: '100px',
    textAlign: 'center',
    cursor: 'pointer',
    zIndex: 10,
    backgroundColor: 'transparent',
    border: 0,
  },
  loader: {
    width: '1210px',
    height: '3000px',
    backgroundColor: '#FFFFFF',
    position: 'absolute',
    zIndex: 9,
  },
});

export default styleSheet;
